const obj = {
  // bs: 'https://nkonkoni.yuri.co.za/api/webApi',
  bs: '/sapi/v1',
  teambs: '/tapi/v1',
  primaryColor: '#FF544F',
};

export default obj;